import {keys} from 'ts-transformer-keys';
import { Configs, DataObjects } from '~/shared/src/utilities/action';


type RequiredKeys<T> = { [K in keyof T]-? : {} extends Pick<T, K> ? never : K }[keyof T];
type RequiredOf<T> = Pick<T, RequiredKeys<T>>;


export type Function = {
    id : number;
    key : string;
    name : string;

    function? : string;
    order : number;
    dataObjects : DataObjects;
    configs? : Configs;
    formElements : {
        [ label : string ] : number;
    }
};
export const functionProps = keys<Function>();
export const requiredFunctionProps = keys<RequiredOf<Function>>();
